import { useCreation } from 'ahooks'

import { PricingMethodEntity } from '@eastcoal/api/trade/interface'
import { queryPricingMethodListApi } from '@eastcoal/api/trade/pricingMethod/queryPricingMethodList'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { PricingMethodSelectProps } from './interface'

const getOptionValue = (item: PricingMethodEntity) => `${item.id}`

const resolveOptions = (data: PricingMethodEntity[]) =>
  data.map(item => ({
    label: item.name,
    value: item.id
  }))

export const PricingMethodSelect = ({
  disabled,
  value,
  onChange,
  supportTradeType,
  kindCode
}: PricingMethodSelectProps) => {
  const requestParams = useCreation(
    () => ({
      supportTradeType,
      kindCode
    }),
    [supportTradeType, kindCode]
  )

  return (
    <RemoteSelect
      allowClear
      api={queryPricingMethodListApi}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={undefined}
      refreshDeps={[kindCode]}
      requestParams={requestParams}
      resolveOptions={resolveOptions}
      value={value}
      onChange={onChange}
    />
  )
}
